import React from 'react';

// Campo trampa: invisible para las personas, irresistible para los bots.
// Se posiciona fuera de pantalla en lugar de usar display:none porque
// varios bots ignoran los campos ocultos con CSS.
const HoneypotField = ({ value, onChange }) => (
  <div
    aria-hidden='true'
    style={{
      position: 'absolute',
      left: '-9999px',
      width: '1px',
      height: '1px',
      overflow: 'hidden',
    }}
  >
    <label htmlFor='website-url'>No completar este campo</label>
    <input
      type='text'
      id='website-url'
      name='website-url'
      tabIndex={-1}
      autoComplete='off'
      value={value}
      onChange={onChange}
    />
  </div>
);

export default HoneypotField;
